"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _utils = require("../../utils");
var _ = require("./..");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var PrescreenerSurvey = function PrescreenerSurvey(_ref) {
  var surveyData = _ref.surveyData,
    disorder = _ref.disorder,
    physicianComment = _ref.physicianComment,
    expanded = _ref.expanded,
    onClickDetail = _ref.onClickDetail,
    foreignSection = _ref.foreignSection,
    foreignSectionPatientAnswers = _ref.foreignSectionPatientAnswers;
  var survey = surveyData.survey,
    patientSurveyAnswers = surveyData.patientSurveyAnswers;
  var CollapsedStateRenderer = /*#__PURE__*/_react.default.createElement("div", {
    className: "text-black tw-body-light"
  }, /*#__PURE__*/_react.default.createElement("p", null, "Result: ", /*#__PURE__*/_react.default.createElement("span", {
    className: "tw-body-medium"
  }, disorder)), physicianComment && /*#__PURE__*/_react.default.createElement("p", null, (0, _utils.getRoleName)(_utils.UserRoles.Doctor), " comment:", ' ', /*#__PURE__*/_react.default.createElement("span", {
    className: "tw-body-medium"
  }, physicianComment)));
  return /*#__PURE__*/_react.default.createElement(_.PatientSurvey, {
    title: "DSM-5",
    surveyData: surveyData,
    expanded: expanded,
    CollapsedStateRenderer: CollapsedStateRenderer,
    onClickDetail: onClickDetail
  }, foreignSection && /*#__PURE__*/_react.default.createElement(_.SurveySection, null, foreignSection.map(function (question) {
    var answer = (0, _.getAnswerForQuestion)(question, foreignSectionPatientAnswers);
    return /*#__PURE__*/_react.default.createElement(_.Question, {
      key: question.id,
      question: question,
      answer: answer
    });
  })), (survey === null || survey === void 0 ? void 0 : survey.sections) && (0, _lodash.map)(survey.sections, function (questions, sectionName) {
    return /*#__PURE__*/_react.default.createElement(_.SurveySection, {
      key: sectionName
    }, filterNonDSMQuestions(questions).map(function (question) {
      var answer = (0, _.getAnswerForQuestion)(question, patientSurveyAnswers);
      return /*#__PURE__*/_react.default.createElement(_.Question, {
        key: question.id,
        question: question,
        answer: answer
      });
    }));
  }));
};
var _default = PrescreenerSurvey;
exports.default = _default;
var filterNonDSMQuestions = function filterNonDSMQuestions(questions) {
  var hasDSMMetadata = questions.some(function (q) {
    var _q$metadata;
    return (_q$metadata = q.metadata) === null || _q$metadata === void 0 ? void 0 : _q$metadata.DSM;
  });

  // Older versions of the prescreener questions wouldn't have DSM metadata
  // because they only contained DSM-V questions, and didn't need to worry about
  // distinguishing between prescreener and intake questions.
  if (!hasDSMMetadata) {
    return questions;
  }

  // Starting on version ID 10 of the Prescreener and version ID 11 of the Intake,
  // there are 4 questions that the patient answers as part of the Prescreener
  // that are duplicated and added to their Intake.
  // However, these questions should not appear under the DSM-V section in the clinician app.
  return questions.filter(function (q) {
    var _q$metadata2;
    return (_q$metadata2 = q.metadata) === null || _q$metadata2 === void 0 ? void 0 : _q$metadata2.DSM;
  });
};